<div class="details-subheader">
  <yc-i18n
    key="BUDGET:textCycleBudgetSelectorHelpText"
    defaultValue="Select the budgets to make available for awards and payments created during the cycle.">
  </yc-i18n>
</div>

<div class="mt-5">
  <yc-table
    [key]="'CYCLE_BUDGETS'"
    [rows]="budgetRows"
    [topLevelFilters]="topLevelFilters"
    [optionsOnNewRow]="true"
    [hideTableFilters]="true"
    [hideTableOptions]="true"
    [bulkOptions]="bulkOptions"
    [bulkSelected]="bulkSelected"
    (bulkSelectedChanged)="bulkSelectedChanged($event)">

    <!-- Budget Name -->
    <ng-container *ycTableColumn="'common:lblName'; 
      let row;
      defaultSortDirection: 'asc',
      prop: 'name',
      filterType: 'text'">
      {{ row.name }}
      <small class="d-block">
        <yc-i18n
          [key]="row.fundingSourceType === FundingSourceTypes.DOLLARS ?
            'GLOBAL:textCash' :
            'GLOBAL:hdrInKind'"
          [defaultValue]="row.fundingSourceType === FundingSourceTypes.DOLLARS ?
            'Cash' :
            'In Kind'">
        </yc-i18n>
      </small>
    </ng-container>

    <!-- Tags -->
    <ng-container *ycTableColumn="'GLOBAL:lblTags'; 
      let row;
      prop: 'budgetTags'">
      {{ $any(budgetTagsMap[row.id] | ycPluck: 'name') | ycJoinArray }}
    </ng-container>

    <!-- Status -->
    <ng-container *ycTableColumn="'common:hdrStatus'; 
      let row;
      prop: 'isClosed',
      filterType: 'boolean'">
      <yc-i18n
        [key]="row.isClosed ? 'GLOBAL:textClosed' : 'GLOBAL:textOpen'"
        [defaultValue]="row.isClosed ? 'Closed' : 'Open'">
      </yc-i18n>
    </ng-container>

    <!-- Available for Payments -->
    <ng-container *ycTableColumn="'common:textAvailableForPayments'; 
      let row;
      prop: 'totalAmountAvailable',
      filterType: 'number'">
      {{ row.totalAmountAvailable | gcMoney }}
    </ng-container>

  </yc-table>
</div>